export class ProductionJobSharedDetail {
	public sharedId: string;
	public title: string;
	public docSizeProduced: number;
	public hasPassword: boolean;
	public jobStatus: string;
	public productionJobId: string;
	public caseId: string;
}

